export default __webpack_public_path__ + "static/media/loader.a25f99dd.svg";